import { createContext } from 'react';

interface PermissionContextType {
  hasRole: (roles: string[]) => boolean;
  roles: string[];
}

export const PermissionsContext = createContext<PermissionContextType>({
  hasRole: () => false,
  roles: [],
});
